<script>
  import { fade } from 'svelte/transition';
  import { t } from 'precompile-intl-runtime';
  import Subcomponents from './Subcomponents';
  import HelpIcon from 'icons/help.svg';

  import ui from '../../../stores/UI';
  import SaveButton from 'components/SaveButton/SaveButton';
  import draft from '../../../stores/Draft';

  $: selectedMenu = $ui.selectedMenu;
  let sidebar;
  export let open = false;

  function selectMenu(index) {
    console.log('select menu', index);
    open = false;
    ui.update((draft) => {
      draft.selectedMenu = draft.selectedMenu === index ? -1 : index;
    });
  }
  function importFromFile(e) {
    let files = e.target.files;
    if (files.length > 0) {
      let file = files[0];
      let reader = new FileReader();
      reader.onload = (readFile) => {
        try {
          let newDraft = JSON.parse(readFile.target.result);
          draft.set(newDraft);
        } catch (e) {
          console.error(e);
        }
      };
      reader.readAsText(file);
    }
  }
</script>

<div class="sidebar-container">
  {#if open}
    <div
      class="sidebar"
      bind:this={sidebar}
      transition:fade={{
        x: -150,
        duration: 20,
        opacity: 1,
      }}
    >
      {#each Subcomponents as item, i}
        <button class="icon-button" on:click={() => selectMenu(i)}>
          <div class={'icon'}>
            {@html item.icon}
          </div>
          <span>{$t(`page.${item.name}.title`)}</span>
        </button>
      {/each}
      <SaveButton />

      <div class="save-load">
        <input
          type="file"
          name="upload"
          id="upload"
          on:input={importFromFile}
        />
        <label class="icon-button button" for="upload"
          >{$t('terms.upload')}</label
        >
      </div>
      <div class="help">
        <a href={`/weaver/docs_${$ui.locale}`}>
          <div class="icon">
            {@html HelpIcon}
          </div>
        </a>
      </div>
    </div>
  {/if}
</div>

<style>
  input[type='file'] {
    display: none;
  }

  .icon {
    fill: var(--color-1);
    stroke: var(--color-1);
    width: 50px;
    height: 50px;
    margin: auto;
    margin-bottom: 5px;
  }

  .icon-button {
    border-radius: 4px;
    border: 1px black;
    color: var(--color-1);
    background-color: #40362a;
    width: min-content;
  }

  .icon-button:hover {
    background-color: var(--color-2);
  }

  .sidebar-container {
    z-index: 10;
    position: relative;
  }

  .sidebar {
    display: flex;
    flex-direction: column;
    align-items: center;

    background-color: #40362a;

    position: absolute;
    top: 0;
    bottom: 0;
    overflow: auto;
  }

  .sidebar > * {
    margin: 10px;
  }

  .help {
    display: flex;
    flex-direction: column-reverse;
    flex-grow: 1;
  }

  .save-load {
    height: 50px;
    color: var(--color-1);
    text-align: center;
  }
</style>
